export default __webpack_public_path__ + "173e40648270a004897d7f85557b03f7.png";